<!-- =========================================================================================
  File Name: scenarioEdit.vue
  Description: Edit Geo Scenario component
========================================================================================== -->


<template>
<sidebar
   :addTitle="$t('GeoScenarioPage.AddScenario')"
   :editTitle="$t('GeoScenarioPage.UpdateScenario')"
   :isSidebarActive="isSidebarActive"
   :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form-wizard
        ref="wizard"
        color="rgba(var(--vs-primary), 1)"
        errorColor="rgba(var(--vs-danger), 1)"
        :title="null"
        :subtitle="null"
        :nextButtonText="$t('Next')"
        :backButtonText="$t('Back')"
        :finishButtonText="$t('Submit')"
        @on-complete="handleSubmit(submitData)"
      >
        <tab-content title="Base" class="mb-2" :before-change="validateStep1">
          <ValidationObserver ref="step1Observer" >
          <!-- Base scenario content -->
            <form data-vv-scope="step-1">
              <vs-row>
                <vs-col class="mb-3" vs-w="12">
                  <ValidationProvider :name="$t('GeoScenarioPage.Name')" rules="required" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.Name')"
                      v-model="scenarioName"
                    ></validated-input>
                    <validation-message
                     >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="5" class="mr-5">
                  <ValidationProvider :name="$t('GeoScenarioPage.DefaultRefiningCharges')" rules="required|decimal:2|between:2,7" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.DefaultRefiningCharges')"
                      v-model="scenarioDefaultRefiningCost"
                      templateSlot="append"
                      templateLabel="$/oz"
                    ></validated-input>
                    <validation-message
                      >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="6" >
                  <ValidationProvider :name="$t('GeoScenarioPage.DefaultRoyalties')" rules="required|decimal:2|between:0,3" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.DefaultRoyalties')"
                      v-model="scenarioDefaultRoyalties"
                      templateSlot="append"
                      templateLabel="%"
                    ></validated-input>
                    <validation-message
                      >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="5" style="padding-right:10px;">
                  <vs-checkbox v-model="scenarioIncludeAg">{{$t('GeoScenarioPage.IncludeSilver')}}</vs-checkbox>
                </vs-col>
                <vs-col vs-w="6" style="padding-left:10px;">
                  <vs-checkbox v-model="scenarioIncludeCu">{{$t('GeoScenarioPage.IncludeCopper')}}</vs-checkbox>
                </vs-col>
              </vs-row>
            </form>
          </ValidationObserver>
        </tab-content>
        <tab-content :title="$t('Gold')" class="mb-2" :before-change="validateStep2">
          <!-- Gold content -->
          <ValidationObserver ref="step2Observer" >
            <form data-vv-scope="step-2">
              <vs-row class="mb-5" vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="6" class="mr-5">
                  <form-label>{{$t('GeoScenarioPage.Estimator')}}</form-label>
                  <ValidationProvider :name="$t('GeoScenarioPage.Estimator')" rules="required" v-slot="{ errors }">
                  <v-select
                    :options="estimatorOptions"
                    :reduce="item => item.value"
                    label="text"
                    v-model="scenarioAuEstimator"
                    class="w-full"
                  ></v-select>
                   <validation-message
                      >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="6">
                  <ValidationProvider :name="$t('GeoScenarioPage.GoldPrice')" rules="required|numeric|between:1,10000" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.GoldPrice')"
                      v-model="scenarioAuPrice"
                      templateSlot="append"
                      templateLabel="$/oz"
                    ></validated-input>
                    <validation-message
                        >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-divider position="center">{{$t('GeoScenarioPage.CNProcess')}}</vs-divider>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="12">
                  <ValidationProvider :name="$t('GeoScenarioPage.CNPayable')" rules="required|decimal:1|between:0,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CNPayable')"
                      v-model="scenarioAuCNPayablePct"
                      templateSlot="append"
                      templateLabel="%"
                    ></validated-input>
                    <validation-message
                          >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="5" class="mr-5">
                  <ValidationProvider :name="$t('GeoScenarioPage.CNRefiningCharge')" rules="required|decimal:2|between:2,7" v-slot="{ errors }">
                  <validated-input
                    :label="$t('GeoScenarioPage.CNRefiningCharge')"
                    v-model="scenarioAuCNRefiningCharge"
                    templateSlot="append"
                    templateLabel="$/oz"
                  ></validated-input>
                  <validation-message
                      >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="6">
                  <ValidationProvider :name="$t('GeoScenarioPage.CNRecoveryPct')" rules="required|decimal:1|between:0,100" v-slot="{ errors }">
                  <validated-input
                    :label="$t('GeoScenarioPage.CNRecoveryPct')"
                    v-model="scenarioAuCNRecoveryPct"
                    templateSlot="append"
                    templateLabel="%"
                  ></validated-input>
                  <validation-message
                      >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <div v-if="scenarioIncludeCu">
                <vs-divider position="center">{{$t('GeoScenarioPage.CuProcess')}}</vs-divider>
                <vs-row vs-type="flex" vs-justify="space-between">
                   <vs-col vs-w="5" class="mr-5">
                    <ValidationProvider :name="$t('GeoScenarioPage.CuPayable')" rules="required|decimal:1|between:0,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CuPayable')"
                      v-model="scenarioAuCuPayablePct"
                      templateSlot="append"
                      templateLabel="%"
                    ></validated-input>
                    <validation-message
                      >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                  </vs-col>
                  <vs-col vs-w="6">
                     <ValidationProvider :name="$t('GeoScenarioPage.PayableDeductable')" rules="required|decimal:1|between:0,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.PayableDeductable')"
                      v-model="scenarioAuCuPayableDeductable"
                      templateSlot="append"
                      templateLabel="g/t"
                    ></validated-input>
                    <validation-message
                      >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                  </vs-col>
                </vs-row>
                <vs-row vs-type="flex" vs-justify="space-between">
                   <vs-col vs-w="5" class="mr-5">
                      <ValidationProvider :name="$t('GeoScenarioPage.CuRefiningCharge')" rules="required|decimal:2|between:3,7" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CuRefiningCharge')"
                      v-model="scenarioAuCuRefiningCharge"
                      templateSlot="append"
                      templateLabel="$/oz"
                    ></validated-input>
                    <validation-message
                      >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                  </vs-col>
                  <vs-col vs-w="6">
                    <ValidationProvider :name="$t('GeoScenarioPage.CuRecoveryPct')" rules="required|decimal:1|between:0,100" v-slot="{ errors }">
                      <validated-input
                        :label="$t('GeoScenarioPage.CuRecoveryPct')"
                        v-model="scenarioAuCuRecoveryPct"
                        templateSlot="append"
                        templateLabel="%"
                      ></validated-input>
                      <validation-message
                        >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                  </vs-col>
                </vs-row>
              </div>
            </form>
          </ValidationObserver>
        </tab-content>
        <tab-content
          v-if="scenarioIncludeAg"
          :title="$t('Silver')"
          class="mb-2"
          :before-change="validateStep3"
        >
          <ValidationObserver ref="step3Observer" >
            <!-- Silver content -->
            <form data-vv-scope="step-3">
              <vs-row class="mb-5" vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="5" class="mr-5">
                  <form-label>{{$t('GeoScenarioPage.Estimator')}}</form-label>
                  <ValidationProvider :name="$t('GeoScenarioPage.Estimator')" rules="required|decimal:1|between:0,100" v-slot="{ errors }">
                    <v-select
                      :options="estimatorOptions"
                      :reduce="item => item.value"
                      label="text"
                      v-model="scenarioAgEstimator"
                      class="w-full"
                      name="scenarioAgEstimator"
                      v-validate="'required'"
                    ></v-select>
                    <validation-message
                          >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="6">
                  <ValidationProvider :name="$t('GeoScenarioPage.SilverPrice')" rules="required|numeric|between:1,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.SilverPrice')"
                      v-model="scenarioAgPrice"
                      templateSlot="append"
                      templateLabel="$/oz"
                    ></validated-input>
                    <validation-message
                          >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-divider position="center">{{$t('GeoScenarioPage.CNProcess')}}</vs-divider>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="12">
                  <ValidationProvider :name="$t('GeoScenarioPage.CNPayable')" rules="required|decimal:1|between:0,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CNPayable')"
                      v-model="scenarioAgCNPayablePct"
                      templateSlot="append"
                      templateLabel="%"
                    ></validated-input>
                    <validation-message
                          >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="space-between">
                 <vs-col vs-w="5" class="mr-5">
                  <ValidationProvider :name="$t('GeoScenarioPage.CNRefiningCharge')" rules="required|decimal:2|between:2,7" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CNRefiningCharge')"
                      v-model="scenarioAgCNRefiningCharge"
                      templateSlot="append"
                      templateLabel="$/oz"
                    ></validated-input>
                    <validation-message
                          >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="6">
                  <ValidationProvider :name="$t('GeoScenarioPage.CNRecoveryPct')" rules="required|decimal:1|between:0,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CNRecoveryPct')"
                      v-model="scenarioAgCNRecoveryPct"
                      templateSlot="append"
                      templateLabel="%"
                    ></validated-input>
                    <validation-message
                          >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <div v-if="scenarioIncludeCu">
                <vs-divider position="center">{{$t('GeoScenarioPage.CuProcess')}}</vs-divider>
                <vs-row vs-type="flex" vs-justify="space-between">
                   <vs-col vs-w="5" class="mr-5">
                    <ValidationProvider :name="$t('GeoScenarioPage.CuPayable')" rules="required|decimal:1|between:0,100" v-slot="{ errors }">
                      <validated-input
                        :label="$t('GeoScenarioPage.CuPayable')"
                        v-model="scenarioAuCuPayablePct"
                        templateSlot="append"
                        templateLabel="%"
                      ></validated-input>
                      <validation-message
                          >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                  </vs-col>
                  <vs-col vs-w="6">
                    <ValidationProvider :name="$t('GeoScenarioPage.PayableDeductable')" rules="required|decimal:1|between:0,100" v-slot="{ errors }">
                      <validated-input
                        :label="$t('GeoScenarioPage.PayableDeductable')"
                        v-model="scenarioAgCuPayableDeductable"
                        templateSlot="append"
                        templateLabel="g/t"
                      ></validated-input>
                      <validation-message
                        >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                  </vs-col>
                </vs-row>
                <vs-row vs-type="flex" vs-justify="space-between">
                   <vs-col vs-w="5" class="mr-5">
                    <ValidationProvider :name="$t('GeoScenarioPage.CuRefiningCharge')" rules="required|decimal:3|between:0.01,7" v-slot="{ errors }">
                      <validated-input
                        :label="$t('GeoScenarioPage.CuRefiningCharge')"
                        v-model="scenarioAgCuRefiningCharge"
                        templateSlot="append"
                        templateLabel="$/oz"
                      ></validated-input>
                      <validation-message
                          >{{ errors[0] }}</validation-message>
                    </ValidationProvider>
                  </vs-col>
                  <vs-col vs-w="6">
                    <ValidationProvider :name="$t('GeoScenarioPage.CuRecoveryPct')" rules="required|numeric|between:0,100" v-slot="{ errors }">
                      <validated-input
                        :label="$t('GeoScenarioPage.CuRecoveryPct')"
                        v-model="scenarioAgCuRecoveryPct"
                        templateSlot="append"
                        templateLabel="%"
                      ></validated-input>
                      <validation-message
                          >{{ errors[0] }}</validation-message>
                    </ValidationProvider>
                  </vs-col>
                </vs-row>
              </div>
            </form>
          </ValidationObserver>
        </tab-content>
        <tab-content
          v-if="scenarioIncludeCu"
          title="Copper"
          class="mb-2"
          :before-change="validateStep4"
        >
          <ValidationObserver ref="step4Observer" >
          <!-- Copper content -->
            <form data-vv-scope="step-4">
              <vs-row class="mb-5" vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="5" class="mr-5">
                  <form-label>{{$t('GeoScenarioPage.Estimator')}}</form-label>
                  <ValidationProvider :name="$t('GeoScenarioPage.Estimator')" rules="required" v-slot="{ errors }">
                    <v-select
                      :options="estimatorOptions"
                      :reduce="item => item.value"
                      label="text"
                      v-model="scenarioCuEstimator"
                      class="w-full"
                    ></v-select>
                    <validation-message
                            >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="6">
                  <ValidationProvider :name="$t('GeoScenarioPage.CopperPrice')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CopperPrice')"
                      v-model="scenarioCuPrice"
                      templateSlot="append"
                      templateLabel="$/lbs"
                    ></validated-input>
                    <validation-message
                            >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-divider position="center">{{$t('GeoScenarioPage.CuProcess')}}</vs-divider>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="5" class="mr-5">
                  <ValidationProvider :name="$t('GeoScenarioPage.CuRefiningCharge')" rules="required|decimal:3|between:0.01,3" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CuRefiningCharge')"
                      v-model="scenarioCuRefiningCharge"
                      templateSlot="append"
                      templateLabel="$/lbs"
                    ></validated-input>
                    <validation-message
                            >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="6">
                  <ValidationProvider :name="$t('GeoScenarioPage.RecoveryPct')" rules="required|numeric|between:0,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.RecoveryPct')"
                      v-model="scenarioCuRecoveryPct"
                      templateSlot="append"
                      templateLabel="%"
                    ></validated-input>
                    <validation-message
                            >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="5" class="mr-5">
                  <ValidationProvider :name="$t('GeoScenarioPage.PayableDeductable')" rules="required|decimal:1|between:0,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.PayableDeductable')"
                      v-model="scenarioCuPayableDeductablePct"
                      templateSlot="append"
                      templateLabel="%"
                    ></validated-input>
                    <validation-message
                            >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="6">
                  <ValidationProvider :name="$t('GeoScenarioPage.CuPayable')" rules="required|decimal:1|between:90,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CuPayable')"
                      v-model="scenarioCuPayablePct"
                      templateSlot="append"
                      templateLabel="%"
                    ></validated-input>
                    <validation-message
                            >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="5" class="mr-5">
                  <ValidationProvider :name="$t('GeoScenarioPage.CuPenalty')" rules="required|numeric|between:0,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CuPenalty')"
                      v-model="scenarioCuPenalty"
                      templateSlot="append"
                      templateLabel="$/mt C"
                    ></validated-input>
                    <validation-message
                            >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="6">
                  <ValidationProvider :name="$t('GeoScenarioPage.CuBaseTreatmentCharge')" rules="required|numeric|between:0,1000" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CuBaseTreatmentCharge')"
                      v-model="scenarioCuBaseTreatmentCharge"
                      templateSlot="append"
                      templateLabel="$/mt C"
                    ></validated-input>
                    <validation-message
                            >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="5" class="mr-5">
                  <ValidationProvider :name="$t('GeoScenarioPage.CuConcentrateQualityPct')" rules="required|numeric|between:0,100" v-slot="{ errors }">
                    <validated-input
                      :label="$t('GeoScenarioPage.CuConcentrateQualityPct')"
                      v-model="scenarioCuConcentrateQualityPct"
                      templateSlot="append"
                      templateLabel="%"
                    ></validated-input>
                    <validation-message
                            >{{ errors[0] }}</validation-message>
                  </ValidationProvider>
                </vs-col>
              </vs-row>
            </form>
          </ValidationObserver>
        </tab-content>
      </form-wizard>
    </ValidationObserver>
  </sidebar>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "../../../shared/components";

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    blockModelId: {
      type: Number,
      default: () => {}
    }
  },
  components: {
    FormWizard,
    TabContent,
    FormLabel,
    ValidatedInput,
    ValidationMessage,
    vSelect,
    Sidebar
  },
  data() {
    return {
      currentUser: null,
      scenarioId: null,
      scenarioBlockModelId: this.blockModelId,
      scenarioName: "",
      scenarioDefaultRefiningCost: 3,
      scenarioDefaultRoyalties: 2,
      scenarioIncludeAg: false,
      scenarioIncludeCu: false,
      scenarioAuPrice: 1500,
      scenarioAuEstimator: null,
      scenarioAuCNPayablePct: null,
      scenarioAuCNRefiningCharge: null,
      scenarioAuCNRecoveryPct: null,
      scenarioAuCuRecoveryPct: null,
      scenarioAuCuPayablePct: null,
      scenarioAuCuPayableDeductable: null,
      scenarioAuCuRefiningCharge: null,
      scenarioAgPrice: null,
      scenarioAgEstimator: null,
      scenarioAgCNPayablePct: null,
      scenarioAgCNRefiningCharge: null,
      scenarioAgCNRecoveryPct: null,
      scenarioAgCuRecoveryPct: null,
      scenarioAgCuPayablePct: null,
      scenarioAgCuPayableDeductable: null,
      scenarioAgCuRefiningCharge: null,
      scenarioCuPrice: null,
      scenarioCuEstimator: null,
      scenarioCuPayable: null,
      scenarioCuRefiningCharge: null,
      scenarioCuRecoveryPct: null,
      scenarioCuConcentrateQualityPct: null,
      scenarioCyPayablePct: null,
      scenarioCuPayableDeductable: null,
      scenarioCuPenalty: null,
      scenarioCuBaseTreatmentCharge: null,
      scenarioCreatedBy: null,
      estimatorOptions: [
        { text: "Ordinary Kriging", value: 0 },
        { text: "Nearest Neighbor", value: 1 },
        { text: "Inverse Power", value: 2 },
        { text: "Uncapped O Krig", value: 3 },
        { text: "Simple Kriging", value: 4 },
        { text: "Sichel T Est", value: 5 }
      ]
    };
  },
  watch: {
    scenarioDefaultRefiningCost(val) {
      this.scenarioDefaultRefiningCost = val;
      this.scenarioAuCNRefiningCharge = val;
      this.scenarioAgCNRefiningCharge = val;
    }
  },
  computed: {
    isDataEmpty() {
      return Object.entries(this.data).length === 0;
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.wizard.reset();
    },
    editData() {
      const {
        id,
        blockModelId,
        name,
        defaultRefiningCost,
        defaultRoyalties,
        auPrice,
        auEstimator,
        auCNPayablePct,
        auCNRefiningCharge,
        auCNRecoveryPct,
        auCuRecoveryPct,
        auCuPayablePct,
        auCuPayableDeductable,
        auCuRefiningCharge,
        agPrice,
        agEstimator,
        agCNPayablePct,
        agCNRefiningCharge,
        agCNRecoveryPct,
        agCuRecoveryPct,
        agCuPayablePct,
        agCuPayableDeductable,
        agCuRefiningCharge,
        cuPrice,
        cuEstimator,
        cuRefiningCharge,
        cuRecoveryPct,
        cuConcentrateQualityPct,
        cuPayablePct,
        cuPayableDeductablePct,
        cuPenalty,
        cuBaseTreatmentCharge,
        createdBy } = JSON.parse(JSON.stringify(this.data));

      this.scenarioId = id;
      this.scenarioBlockModelId = blockModelId;
      this.scenarioName = name;
      this.scenarioDefaultRefiningCost = defaultRefiningCost;
      this.scenarioDefaultRoyalties = defaultRoyalties;
      this.scenarioAuPrice = auPrice;
      this.scenarioAuEstimator = auEstimator;
      this.scenarioAuCNPayablePct = auCNPayablePct;
      this.scenarioAuCNRefiningCharge = auCNRefiningCharge;
      this.scenarioAuCNRecoveryPct = auCNRecoveryPct;
      this.scenarioAuCuRecoveryPct = auCuRecoveryPct;
      this.scenarioAuCuPayablePct = auCuPayablePct;
      this.scenarioAuCuPayableDeductable = auCuPayableDeductable;
      this.scenarioAuCuRefiningCharge = auCuRefiningCharge;
      this.scenarioIncludeAg = agPrice !== null && agPrice !== 0;

      this.scenarioAgPrice = agPrice;
      this.scenarioAgEstimator = agEstimator;
      this.scenarioAgCNPayablePct = agCNPayablePct;
      this.scenarioAgCNRefiningCharge = agCNRefiningCharge;
      this.scenarioAgCNRecoveryPct = agCNRecoveryPct;
      this.scenarioAgCuRecoveryPct = agCuRecoveryPct;
      this.scenarioAgCuPayablePct = agCuPayablePct;
      this.scenarioAgCuPayableDeductable = agCuPayableDeductable;
      this.scenarioAgCuRefiningCharge = agCuRefiningCharge;

      this.scenarioIncludeCu = cuPrice !== null && cuPrice !== 0;

      this.scenarioCuPrice = cuPrice;
      this.scenarioCuEstimator = cuEstimator;
      this.scenarioCuRefiningCharge = cuRefiningCharge;
      this.scenarioCuRecoveryPct = cuRecoveryPct;
      this.scenarioCuConcentrateQualityPct = cuConcentrateQualityPct;
      this.scenarioCuPayablePct = cuPayablePct;
      this.scenarioCuPayableDeductablePct = cuPayableDeductablePct;
      this.scenarioCuPenalty = cuPenalty;
      this.scenarioCuBaseTreatmentCharge = cuBaseTreatmentCharge;
      this.scenarioCreatedBy = createdBy;

      this.$refs.wizard.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;

      this.scenarioId = null;
      this.scenarioBlockModelId = this.blockModelId;
      this.scenarioName = "";
      this.scenarioDefaultRefiningCost = 3;
      this.scenarioDefaultRoyalties = 2;
      this.scenarioIncludeAg = false;
      this.scenarioIncludeCu = false;
      this.scenarioAuPrice = 1500;
      this.scenarioAuEstimator = null;
      this.scenarioAuCNPayablePct = null;
      this.scenarioAuCNRefiningCharge = null;
      this.scenarioAuCNRecoveryPct = null;
      this.scenarioAuCuRecoveryPct = null;
      this.scenarioAuCuPayablePct = null;
      this.scenarioAuCuPayableDeductable = null;
      this.scenarioAuCuRefiningCharge = null;
      this.scenarioAgPrice = null;
      this.scenarioAgEstimator = null;
      this.scenarioAgCNPayablePct = null;
      this.scenarioAgCNRefiningCharge = null;
      this.scenarioAgCNRecoveryPct = null;
      this.scenarioAgCuRecoveryPct = null;
      this.scenarioAgCuPayablePct = null;
      this.scenarioAgCuPayableDeductable = null;
      this.scenarioAgCuRefiningCharge = null;
      this.scenarioCuPrice = null;
      this.scenarioCuEstimator = null;
      this.scenarioCuRefiningCharge = null;
      this.scenarioCuRecoveryPct = null;
      this.scenarioCuConcentrateQualityPct = null;
      this.scenarioCuPayablePct = null;
      this.scenarioCuPayableDeductablePct = null;
      this.scenarioCuPenalty = null;
      this.scenarioCuBaseTreatmentCharge = null;
      this.scenarioCreatedBy = null;

      this.$refs.wizard.reset();
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$refs.step1Observer.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$refs.step2Observer.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep3() {
      return new Promise((resolve, reject) => {
        this.$refs.step3Observer.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep4() {
      return new Promise((resolve, reject) => {
        this.$refs.step4Observer.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    submitData() {
      
      const obj = {
        id: this.scenarioId,
        blockModelId: this.scenarioBlockModelId,
        name: this.scenarioName,
        defaultRefiningCost: Number(this.scenarioDefaultRefiningCost),
        defaultRoyalties: Number(this.scenarioDefaultRoyalties),
        auPrice: Number(this.scenarioAuPrice),
        auEstimator: Number(this.scenarioAuEstimator),
        auCNPayablePct: Number(this.scenarioAuCNPayablePct),
        auCNRefiningCharge: Number(this.scenarioAuCNRefiningCharge),
        auCNRecoveryPct: Number(this.scenarioAuCNRecoveryPct),
        auCuRecoveryPct: Number(this.scenarioAuCuRecoveryPct),
        auCuPayablePct: Number(this.scenarioAuCuPayablePct),
        auCuPayableDeductable: Number(this.scenarioAuCuPayableDeductable),
        auCuRefiningCharge: Number(this.scenarioAuCuRefiningCharge),
        agPrice: Number(this.scenarioAgPrice),
        agEstimator: Number(this.scenarioAgEstimator),
        agCNPayablePct: Number(this.scenarioAgCNPayablePct),
        agCNRefiningCharge: Number(this.scenarioAgCNRefiningCharge),
        agCNRecoveryPct: Number(this.scenarioAgCNRecoveryPct),
        agCuRecoveryPct: Number(this.scenarioAgCuRecoveryPct),
        agCuPayablePct: Number(this.scenarioAgCuPayablePct),
        agCuPayableDeductable: Number(this.scenarioAgCuPayableDeductable),
        agCuRefiningCharge: Number(this.scenarioAgCuRefiningCharge),
        cuPrice: Number(this.scenarioCuPrice),
        cuEstimator: Number(this.scenarioCuEstimator),
        cuRefiningCharge: Number(this.scenarioCuRefiningCharge),
        cuRecoveryPct: Number(this.scenarioCuRecoveryPct),
        cuConcentrateQualityPct: Number(
          this.scenarioCuConcentrateQualityPct
        ),
        cuPayablePct: Number(this.scenarioCuPayablePct),
        cuPayableDeductablePct: Number(this.scenarioCuPayableDeductablePct),
        cuPenalty: Number(this.scenarioCuPenalty),
        cuBaseTreatmentCharge: Number(this.scenarioCuBaseTreatmentCharge),
        includeAg:
          this.scenarioAgPrice !== null && this.scenarioAgPrice !== 0,
        includeCu:
          this.scenarioCuPrice !== null && this.scenarioCuPrice !== 0,
        createdBy: this.scenarioCreatedBy
      };

      if (this.scenarioId !== null && this.scenarioId >= 0) {
        this.$store.dispatch("scenarioList/updateItem", obj).then(() => {
          this.initValues();
          this.$emit("onSavedScenario");
        });
      } else {
        obj.createdBy = this.currentUser;
        delete obj.id;
        this.$store.dispatch("scenarioList/addItem", obj).then(() => {
          this.initValues();
          this.$emit("onSavedScenario");
        });
      }
    }
  }
};
</script>
